import React from "react";
import HighD from "./result/HighD";
import HighS from "./result/HighS";
import HighI from "./result/HighI";
import HighC from "./result/HighC";
import CIS from "./result/CIS";
import IS from "./result/IS";
import DI from "./result/DI";
import SI from "./result/SI";
import SCD from "./result/SCD";
import HighDI from "./result/HighDI";
import IC from "./result/IC";
import CS from "./result/CS";
import DC from "./result/DC";

const ResultWrapper = ({ result }) => {
  if (result?.result?.result?.name === "Result-oriented(نتیجه گرا) DI") {
    return <DI testResult={result} />;
  }

  if (result?.result?.result?.name === "Counselor(مشاور) IS") {
    return <IS testResult={result} />;
  }

  if (result?.result?.result?.name === "Pratitioner(تمرین کننده)CIS") {
    return <CIS testResult={result} />;
  }

  if (
    result?.result?.result?.name === "Objective thinker(متفکر هدفمند) High C"
  ) {
    return <HighC testResult={result} />;
  }

  if (result?.result?.result?.name === "Promoter (ترویج دهنده) High I") {
    return <HighI testResult={result} />;
  }

  if (result?.result?.result?.name === "Specialist(متخصص) High S") {
    return <HighS testResult={result} />;
  }

  if (result?.result?.result?.name === "Developer(توسع دهنده) High D") {
    return <HighD testResult={result} />;

  }

  if (result?.result?.result?.name === "Agent(نماینده) SI") {
    return <SI testResult={result} />;
  }

  // TODO: نام دقیق الگو High DI را جایگزین کن
  if (result?.result?.result?.name === "Inspirational(الهام بخش) High DI") {
    return <HighDI testResult={result} />;
  }

  // TODO: نام دقیق الگو IC را جایگزین کن
  if (result?.result?.result?.name === "Appraiser(ارزیاب)IC") {
    return <IC testResult={result} />;
  }

    if (result?.result?.result?.name === "Investigator(محقق)SCD") {
    return <SCD testResult={result} />;
  }

  // TODO: نام دقیق الگو CS را جایگزین کن
  if (result?.result?.result?.name === "Perfectionist(کمالگرا) CS") {
    return <CS testResult={result} />;
  }

  // TODO: نام دقیق الگو DC را جایگزین کن
  if (result?.result?.result?.name === "Creative (سازنده) DC") {
    return <DC testResult={result} />;
  }
};

export default ResultWrapper;